
import { StyleValue } from '@/shared/app/model/StyleValue';
import BaseDish from '@shared/dish/ui/Dish.vue';
import Component from 'vue-class-component';
import { TemplateMaker } from '../../../makers/types/template-maker';

@Component
export default class UniLine extends BaseDish {
  get lineStyle(): StyleValue {
    const s: StyleValue = {};
    return s;
  }

  get nameStyle(): StyleValue {
    const s: StyleValue = {
      ...(this.config.nameTextColor && { color: this.config.nameTextColor.toString() }),

      fontWeight: this.config.nameFontWeight?.toString() || '400',
      fontFamily: this.config.nameFontFamily?.toString() || 'Roboto',
      fontSize: `${this.sizeFactor * this.nameSizeFactor * 0.8}rem`,
    };
    return s;
  }

  get priceStyle(): StyleValue {
    let s: StyleValue = {
      padding: `${this.sizeFactor * this.priceSizeFactor * 0.2}rem ${this.sizeFactor * 0.4}rem`,

      ...(this.config.priceTextColor && { color: this.config.priceTextColor.toString() }),
      fontFamily: this.config.priceFontFamily?.toString() || 'Roboto',
      fontSize: `${this.sizeFactor * this.priceSizeFactor * 0.68}rem`,

      ...(this.config.priceWidth && { width: this.config.priceWidth.toString() }),
      ...(this.config.priceFullHeight && { flexGrow: 1 }),
    };
    if (this.config.priceBackgroundColor) {
      s = {
        ...s,
        backgroundColor: this.config.priceBackgroundColor.toString(),
      }
    }
    return s;
  }

  get rightBlockStyle(): StyleValue {
    const s: StyleValue = {
      marginLeft: `${this.sizeFactor * 0.5}rem`,
    };
    return s;
  }

  get showPrice() {
    return Boolean(this.price) && !this.config.hidePrice;
  }

  get priceSizeFactor() {
    return Number(this.config.priceSizeFactor) || 1;
  }

  get nameSizeFactor() {
    if (this.name?.length > 39) return 0.9;
    return 1;
  }
}

export type UniLineConfig = {
  sizeFactor?: number;
  padding?: string;

  nameTextColor?: string;
  nameFontFamily?: string;
  nameFontWeight?: StyleValue['fontWeight'];

  hidePrice?: boolean;
  priceFullHeight?: boolean;
  priceWidth?: string;
  priceFontFamily?: string;
  priceTextColor?: string;
  priceBackgroundColor?: string;
}

type UniLineMakeArgs = {
  config?: UniLineConfig;
}

export const makeUniLine: TemplateMaker<UniLineMakeArgs> = (args) => {
  return {
    component: 'Line',
    config: {},
    slots: {},
  }
}

